(function () {
    'use strict';

    angular.module('app').controller('RateCardPrevModalController', RateCardPrevModalController);

    RateCardPrevModalController.$inject = [
        'Carrier', 
        'serviceRate', 
        'CarrierLoadRatesTableService', 
        '$uibModal', 
        '$uibModalInstance', 
        '$q',
        '$scope',
        'toastr', 
        'rateType'
    ];

    function RateCardPrevModalController(
        Carrier, 
        serviceRate, 
        CarrierLoadRatesTableService, 
        $uibModal, 
        $uibModalInstance,
        $q, 
        $scope,
        toastr, 
        rateType
    ) {
        var vm = this;
        vm.openHistory = openHistory;
        vm.closeModal = closeModal;
        vm.sending = false;
        vm.sendRateCard = sendRateCard;
        var previewModal = $uibModalInstance;
        
        init();

        function init() {
            vm.rateCardPreviewTable = vm.pendingImportTable = serviceRate;
            getRatesData(vm.rateCardPreviewTable);

            vm.pendingImportTable = angular.extend(new CarrierLoadRatesTableService(serviceRate, {isPreview: true, rateType:rateType}).tableData, {
                optionAddOns: {
                    url: '/templates/pages/carriers/RateCardModal/RateCardPrevTableHeader.html',
                    data: serviceRate
                }
            });
        }

        function getRatesData(serviceProfile) {
            if(angular.getObjVal(serviceProfile, 'service.rateCategories')) {
                angular.forEach(serviceProfile.service.rateCategories, rateType=>{
                    rateType.table = new CarrierLoadRatesTableService(angular.copy(serviceProfile), {
                        isPreview: true,
                        rateType: angular.copy(rateType)
                    }).tableData;
                });
            }
        }

        /*for(var x=0;x<=20;x++){
            vm.rateCardPreviewTable.data.push({});
        };*/
        function closeModal() {
            previewModal.close();
        }
        function sendRateCard(form) {
            if(form.$invalid){
                return false;
            }

            vm.sending = true;
            Carrier.sendRatePreview(serviceRate.id, data=>{
                toastr.success('Rate card successfully sent.', 'Email Sent');
                vm.cc = null;
                vm.recipient = null;
                vm.sending = false;
                form.$setPristine();
                form.$setUntouched();

            },error=>{
                toastr.error('Unable to send rate card', error.message);
                vm.sending = false;
            }, {
                recipients: [
                    vm.recipient
                ],
                cc: [
                    vm.cc
                ]
            });
        }
        function openHistory() {
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/pages/carriers/RateCardModal/RateCardHistoryModal.html',
                controller: function ($uibModalInstance, RateHistoryTableService) {
                    var historyModal = $uibModalInstance;
                    var hm = this;
                    hm.closeHistory = closeHistory;

                    hm.rateCardHistoryTable = new RateHistoryTableService(serviceRate.id).tableData;

                    function closeHistory() {
                        historyModal.close();
                    }
                },
                controllerAs: 'hm',
                size: 'lg',
                appendTo: $('body')
            });

            modalInstance.result.then(function (data) {
                console.log(data);
            }, function () {
            });
        }

        const historyData = [
            {
                "date": "01/01/2017",
                "name": "Sample Rate Card 1",
                "carrierProfileName": "TNT",
                "serviceProfileName": "Road Express 1 - Road Express",
                "recipient": "email@email.com",
                "cc": "copy@copy.com",
                "createdBy": "john@doe.com"
            },
            {
                "date": "01/01/2017",
                "name": "Sample Rate Card 1",
                "carrierProfileName": "TNT",
                "serviceProfileName": "Road Express 1 - Road Express",
                "recipient": "email@email.com",
                "cc": "copy@copy.com",
                "createdBy": "john@doe.com"
            },
            {
                "date": "01/01/2017",
                "name": "Sample Rate Card 1",
                "carrierProfileName": "TNT",
                "serviceProfileName": "Road Express 1 - Road Express",
                "recipient": "email@email.com",
                "cc": "copy@copy.com",
                "createdBy": "john@doe.com"
            },
            {
                "date": "01/01/2017",
                "name": "Sample Rate Card 1",
                "carrierProfileName": "TNT",
                "serviceProfileName": "Road Express 1 - Road Express",
                "recipient": "email@email.com",
                "cc": "copy@copy.com",
                "createdBy": "john@doe.com"
            },
            {
                "date": "01/01/2017",
                "name": "Sample Rate Card 1",
                "carrierProfileName": "TNT",
                "serviceProfileName": "Road Express 1 - Road Express",
                "recipient": "email@email.com",
                "cc": "copy@copy.com",
                "createdBy": "john@doe.com"
            }
        ];
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/RateCardPrevModalController.js